import { request } from "./api";
export const getStartingPrice = async ({ token, audience, }) => request({
    url: `https://accounts.${audience}/external/organizations/startingPrice`,
    camundaAuth: { token },
    responseType: "json",
});
export const leaveOrganization = async ({ token, audience, orgId, }) => request({
    url: `https://accounts.${audience}/external/organizations/${orgId}/membership`,
    camundaAuth: { token },
    method: "delete",
});
